module.exports = __webpack_public_path__ + "media/svg/edit_square-f1c7d88f.svg";